import dayjs from 'dayjs'
// import ptBr from 'dayjs/locale/pt-br'
import localizedDate from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import { useI18n } from 'vue-i18n'
import 'dayjs/locale/en'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/es'

export function useDayJs() {
  const { locale } = useI18n()

  dayjs.extend(relativeTime)
  dayjs.extend(localizedDate)
  dayjs.extend(utc)

  const formatDate = (date, format = 'YYYY-MM-DD') => dayjs(date).utc().format(format)

  const formatDateRaw = (date, format = 'YYYY-MM-DD') => dayjs(date).format(format)

  const formatDateUtc = (date, format = 'YYYY-MM-DD') => dayjs.utc(date).format(format)

  const formatTime = date => dayjs(date).utc().format('HH:mm:ss')

  const formatTimeRaw = date => dayjs(date).format('HH:mm:ss')

  const formatToBrazilianDate = date => dayjs(date).utc().format('DD/MM/YYYY')

  const formatToBrazilianDatetime = (date, stringFormat) =>
    dayjs(date).format(stringFormat)

  const diffForHumans = timestamp => dayjs.unix(timestamp).utc().fromNow()

  const now = () => dayjs().format()

  const addDays = days => dayjs().utc().add(days, 'day').toString()

  const addHours = hours => dayjs().utc().add(hours, 'hour').toString()

  const addDaysToDate = (date, days) =>
    dayjs(date).utc().add(days, 'day').format()

  const isBrazilianDate = date => dayjs(date, 'DD/MM/YYYY').utc().isValid()

  const timeElapsed = (date, locale) => dayjs(date).locale(locale || 'en').fromNow()

  const dayJsObject = date => dayjs(date)

  const localeFormattedDate = (date) => {
    if (locale.value === 'en') {
      return dayjs(date).format('MM/DD/YYYY')
    }

    return dayjs(date).format('DD/MM/YYYY')
  }

  return {
    formatDate,
    formatDateRaw,
    formatDateUtc,
    formatTime,
    formatTimeRaw,
    formatToBrazilianDate,
    diffForHumans,
    now,
    addDays,
    addHours,
    addDaysToDate,
    isBrazilianDate,
    formatToBrazilianDatetime,
    timeElapsed,
    dayJsObject,
    localeFormattedDate,
  }
}
